import React, { useState, useEffect } from 'react';
import { FaTimes, FaOm, FaPaperPlane, FaStar } from 'react-icons/fa';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', subject: '', message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: process.env.REACT_APP_WEB3FORMS_ACCESS_KEY,
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          subject: formData.subject ? `Consultation Request: ${formData.subject}` : 'General Inquiry',
          message: formData.message,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        setTimeout(() => {
          setSubmitted(false);
          onClose();
        }, 3000);
      }
    } catch (error) {
      // Silently handle network errors
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close modal">
          <FaTimes />
        </button>

        <div className="text-center mb-6">
          <FaOm className="text-[2rem] text-accent-gold mb-2.5 mx-auto" />
          <h2 className="text-[1.4rem] text-primary-dark mb-1.5 font-heading">Book Your Consultation</h2>
          <p className="text-[0.82rem] text-warm-gray">Fill in your details and we'll get back to you with cosmic guidance</p>
        </div>

        {submitted && (
          <div className="flex items-center gap-2 py-3 px-4 bg-[rgba(46,204,113,0.1)] border border-[rgba(46,204,113,0.3)] rounded-lg text-[#27ae60] text-sm mb-4">
            <FaStar /> Thank you! We'll contact you soon.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-semibold text-primary-dark mb-1.5">Full Name *</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required className="modal-input" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-primary-dark mb-1.5">Email *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required className="modal-input" />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
            <div>
              <label className="block text-xs font-semibold text-primary-dark mb-1.5">Phone *</label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your phone number" required className="modal-input" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-primary-dark mb-1.5">Service</label>
              <select name="subject" value={formData.subject} onChange={handleChange} className="modal-input">
                <option value="">Select a service</option>
                <option value="career">Career Advice</option>
                <option value="medical">Medical Astrology</option>
                <option value="gem">Gem Suggestion</option>
                <option value="marriage">Marriage & Progeny</option>
                <option value="horoscope">Horoscope Making</option>
                <option value="matchmaking">Match Making</option>
                <option value="graha-shanti">Graha Shanti</option>
                <option value="kp">KP Astrology</option>
                <option value="muhurta">Muhurta Astrology</option>
                <option value="vastu">Vastu Consultation</option>
              </select>
            </div>
          </div>

          <div className="mt-4">
            <label className="block text-xs font-semibold text-primary-dark mb-1.5">Your Message</label>
            <textarea name="message" rows="3" value={formData.message} onChange={handleChange}
              placeholder="Describe your concern or share your birth details (Date, Time, Place of birth)..."
              className="modal-input resize-y min-h-[80px]" />
          </div>

          <button type="submit" disabled={loading} className="btn-primary w-full justify-center py-3.5 mt-5 text-[0.95rem]">
            <FaPaperPlane /> {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
